import type { RouteRecordRaw } from 'vue-router';

import type { LegalDocumentName } from './types';

// The current app's addresses, so its links keep working once this app serves
// app.ohmy.bible. Public: they are read before signing in.

export const privacyPolicyRoute: RouteRecordRaw = {
  path: '/public-privacy-policy',
  name: 'PublicPrivacyPolicy',
  component: () => import('./pages/LegalDocumentPage.vue'),
  props: { document: 'privacyPolicy' satisfies LegalDocumentName },
  meta: {
    public: true,
    depth: 1,
  },
};

export const termsOfUseRoute: RouteRecordRaw = {
  path: '/public-terms-of-use',
  name: 'PublicTermsOfUse',
  component: () => import('./pages/LegalDocumentPage.vue'),
  props: { document: 'termsOfUse' satisfies LegalDocumentName },
  meta: {
    public: true,
    depth: 1,
  },
};
